import { Typography } from "@mui/material";
import MoedaText from "../ui/inputs/moedaText";
import { map } from "lodash";
import InteiroText from "../ui/inputs/inteiroText";
import PosicaoAtivo from "../../../models/posicaoAtivo";
import TabelaBase from "./tabelaBase";
import Ticker from "../ui/ticker";

type Props = {
  ativos: PosicaoAtivo[] | undefined;
  loading?: boolean;
};

export default function TabelaAtivos({ ativos, loading }: Props) {
  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Ativo", key: "ativo", ordem: 1, align: "center" },
    { titulo: "C/V", key: "cv", ordem: 2, align: "center" },
    { titulo: "Mercado", key: "mercado", ordem: 3, align: "center" },
    { titulo: "Prazo", key: "prazo", ordem: 4, align: "right" },
    { titulo: "PM", key: "precoMedio", ordem: 5, align: "right" },
    { titulo: "Qtd.", key: "quantidade", ordem: 6, align: "right" },
    {
      titulo: "Valor Apl.",
      key: "valorTotal",
      ordem: 7,
      align: "right",
    },
  ];

  const rows = map(ativos, (ativo) => ({
    mercado: celulaMercado(ativo),
    cv: celulaCV(ativo),
    ativo: celulaAtivo(ativo),
    prazo: celulaPrazo(ativo),
    quantidade: celulaQuantidade(ativo),
    precoMedio: celulaPrecoMedio(ativo),
    valorTotal: celulaValorTotal(ativo),
  }));

  return <TabelaBase header={header} rows={rows} loading={loading} />;
  function celulaMercado(ativo: PosicaoAtivo): JSX.Element {
    return celulaTexto(ativo.mercado);
  }

  function celulaCV(ativo: PosicaoAtivo): JSX.Element {
    return celulaTexto(ativo.tipoOperacao);
  }

  function celulaAtivo(ativo: PosicaoAtivo): JSX.Element {
    return <Ticker codigoAtivo={ativo.codigoAtivo} />;
  }

  function celulaPrazo(ativo: PosicaoAtivo): JSX.Element {
    return (
      <Typography variant="dataMono">
        {ativo.prazo?.format("DD/MM/YYYY")}
      </Typography>
    );
  }

  function celulaQuantidade(ativo: PosicaoAtivo): JSX.Element {
    return (
      <Typography variant="dataMono">
        <InteiroText
          value={ativo.quantidade}
          displayType={"text"}
        ></InteiroText>
      </Typography>
    );
  }

  function celulaPrecoMedio(ativo: PosicaoAtivo): JSX.Element {
    return (
      <Typography variant="dataMono">
        <MoedaText displayType={"text"} value={ativo.precoMedio}></MoedaText>
      </Typography>
    );
  }

  function celulaValorTotal(ativo: PosicaoAtivo): JSX.Element {
    return (
      <Typography variant="dataMono">
        <MoedaText displayType={"text"} value={ativo.valorTotal}></MoedaText>
      </Typography>
    );
  }

  function celulaTexto(texto?: string): JSX.Element {
    return <Typography>{texto}</Typography>;
  }
}
